// Getters
export const NEW_DISCOUNT_COUPON_SIDEBAR = 'discount_counpon/NEW_DISCOUNT_COUPON_SIDEBAR'
export const DISCOUNT_COUPONS_SEARCH_RESULT = 'discount_coupon/DISCOUNT_COUPONS_SEARCH_RESULT'

// Mutations
export const MUTATE_NEW_DISCOUNT_COUPON_SIDEBAR = 'discount_coupon/MUTATE_NEW_DISCOUNT_COUPON_SIDEBAR'
export const MUTATE_DISCOUNT_COUPONS_SEARCH_RESULT = 'discount_coupon/MUTATE_DISCOUNT_COUPONS_SEARCH_RESULT'


// Actions
export const OPEN_NEW_DISCOUNT_COUPON_SIDEBAR = 'discount_coupon/OPEN_NEW_DISCOUNT_COUPON_SIDEBAR'
export const SAVE_DISCOUNT_COUPON = 'discount_coupon/SAVE_DISCOUNT_COUPON'
export const GET_DISCOUNT_COUPON = 'discount_coupon/GET_DISCOUNT_COUPON'
export const GET_APP_PAYMENT_RULES = 'discount_coupon/GET_APP_PAYMENT_RULES'
export const SEARCH_DISCOUNT_COUPONS = 'discount_coupon/SEARCH_DISCOUNT_COUPONS'
export const TOGGLE_DISCOUNT_COUPON_STATUS = 'discount_coupon/TOGGLE_DISCOUNT_COUPON_STATUS'
